import * as React from 'react'
import mapboxgl from 'mapbox-gl'

const MapContext = React.createContext<mapboxgl.Map | null>(null)

export const useMap = (): mapboxgl.Map | null => React.useContext(MapContext)

export default MapContext
